const CompanySettingsTab = {
    SETTINGS: 0,
    LOGO: 1,
    S3_SETTINGS: 2,
    LOCALISATION_SETTINGS: 3,
}

export default CompanySettingsTab;